var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.siteTypes,"item-text":"keyAlias","dense":"","item-value":"key","rules":_vm.rules,"error-messages":_vm.errors !== undefined ? _vm.errors : [],"label":"نوع کیفیت سایت","outlined":"","return-object":_vm.return_object},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }